import { ENVIRONMENT } from '@/shared/conf';
import { createLogger } from '@platform/shared';

globalThis.logger = createLogger(ENVIRONMENT || 'production');

export const logger = globalThis.logger;
